const controllers = {
  home: require("./views/home"),
  'dashboard': require('./views/dashboard'),

};

export default controllers;
